import { CRM_ROLES } from './constants/roles';

/**
 * Consumed by the shell to build the top-nav tab + left sidebar entry (`store/modules/navigation.ts`
 * wiring point #3 in CRM_ARCHITECTURE.md §7). Sidebar sub-items are derived from `crmRoutes`'
 * children `meta` — this object only describes the top-level tab itself.
 */
export const crmNavConfig = {
    name: 'crm',
    title: 'crm.pageName',
    path: '/crm',
    prependIcon: 'mdi-handshake-outline',
    featureFlag: 'CRM',
    allowedRoles: [...CRM_ROLES],
} as const;
